import { type TranslationTree } from '@/i18n/types';

export const messages = {
  add: 'Adicionar banner',
  replace: 'Trocar banner',
  remove: 'Remover banner',
  alt: 'Banner do evento',
  hint: 'JPG, PNG ou WebP até 5 MB, no formato 16:9. Sem banner, o app mostra o logo da conta.',
  invalidImage: 'Use uma imagem JPG, PNG ou WebP',
  cropTitle: 'Ajustar banner',
} satisfies TranslationTree;
